module.exports = __webpack_public_path__ + "static/media/ico_simulation_lip_cupidsbow.674f8bcb.png";